/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioProveedoresCV from './controladorVista/formularioProveedoresCV';
import TablaProveedoresCV from './controladorVista/tablaProveedoresCV';
import { estadoIncial, reductor } from './reductorProveedores';

const Proveedores: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaProveedoresCV />
        <FormularioProveedoresCV />
    </ProveedorEstado>
);

export default Proveedores;
